import { Button, Divider, Grid, Typography } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import errorConvertor from '../../../services/errorConvertor';
import { invokePostService, setFocusElement, setReRender, toggleRightDrawer } from '../../../store/global/actions';

export default function DeleteDigitalTwin({ element, onClose, onCompletion, setShowDeleteAlert}) {
    const dispatch = useDispatch();
    const [transactionForEvents, setTransactionForEvents] = useState([]);
    const [associatedItems, setAssociatedItems] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [isForceDelete, setIsForceDelete] = useState(false);
    const [loading, setLoading] = useState(false);

    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteClusterlet', { isForceDelete }, [element.id])).then(res => {
            
            if (res?.status === true) {
                onCompletion(`${process.env.REACT_APP_ANALYTICS}`, 'delete');
            } else {
                if (res?.data?.validationErrors?.length > 0 || res?.data?.associatedItems?.length > 0) {
                    setIsForceDelete(true);
                }
                const converter = new errorConvertor(res?.data?.validationErrors ? res?.data?.validationErrors : [])
                converter.customConvert('The [item] is used in [feature] [featureEntity]');
                setAssociatedItems(res?.data?.associatedItems ? res?.data?.associatedItems : []);
                setValidationErrors([...converter.sentences]);
                const associatedTransactions = [...new Set(res?.data?.associatedTransaction ? res?.data?.associatedTransaction : [])].sort((a, b) => {
                    if (a < b) return -1;
                    if (a > b) return 1;
                    return 0;
                  });
                setTransactionForEvents(associatedTransactions);
                if (res?.code === 254){
                    setShowDeleteAlert(false);
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
            setLoading(false);
        });
    }
    console.log("transactionForEvents-----", transactionForEvents)
    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12}>
                <Typography variant="h6" >Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider/>
            </Grid>


            { transactionForEvents?.length > 0 && 
                <Grid item xs={12} style={{padding: '10px'}}>
                    <Typography style={{marginBottom: '10px'}}> Are you sure you want to delete the {process.env.REACT_APP_ANALYTICS} {element.name}? </Typography>
                    <Typography color="error">
                        {transactionForEvents?.length === 1 ? (
                            `This ${process.env.REACT_APP_ANALYTICS} is associated with the transaction '${transactionForEvents[0]}'. Please delete that first.`
                        ) : (
                            `This ${process.env.REACT_APP_ANALYTICS} is associated with multiple transactions. Please delete them first.`
                        ) }

                    </Typography>
                    {transactionForEvents?.length > 1 && <Fragment>
                        <br/>
                        <ol id="validaionErrors">
                            {transactionForEvents.map((item, index) => {

                                return (
                                    <li key={index}>
                                        {item}
                                    </li>
                                );
                            })}
                        </ol>
                    </Fragment>}
                </Grid>
            }


            {transactionForEvents?.length === 0 && 
                <Grid item xs={12} style={{padding: '10px'}}>
                    {associatedItems?.length > 0 && <Fragment>
                        <Typography> Deleting this node will delete the following entities </Typography>
                        <br />
                        <ol>
                            {associatedItems?.map((item, index) =>
                                <li key={index}>  {item} </li>
                            )}
                        </ol>
                    </Fragment>}
                    <Fragment>
                        <Typography> Are you sure you want to delete the {process.env.REACT_APP_ANALYTICS} {element.name}? </Typography>
                    </Fragment>
                    {validationErrors?.length > 0 && <Fragment>
                        <br/>
                        <ol id="validaionErrors">
                            {validationErrors.map((item, index) => {
                                const words = item.error.split(' ');
                                const lastWord = words.pop();
                                const restOfText = words.join(' ');
                                const boldStyle = { fontWeight: 'bold' };

                                return (
                                    <li key={index}>
                                        {restOfText}{' '}
                                        <span style={{ fontWeight: 'bold' }}>{lastWord}</span>
                                    </li>
                                );
                            })}
                        </ol>
                    </Fragment>}
                </Grid>
            }

            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <Button color="primary" variant="outlined" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onClose}> Cancel </Button>
                <Button color="secondary" variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onDelete} disabled={loading || transactionForEvents.length}> {loading ? 'Deleting..' : isForceDelete ? 'Delete Anyway' : 'Delete'}  </Button>
            </Grid>


        </Grid>
    )
}